// extracted by mini-css-extract-plugin
export default {"addInfo_main_block":"AdditionalInfo_addInfo_main_block__Y2k+9","checkbox_items":"AdditionalInfo_checkbox_items__F30A0","codeInput":"AdditionalInfo_codeInput__6pw9U"};